import "./style.css";
export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-body w-full h-100dvh fixed top-50% left-50% translate-[-50%] z-999 bg-[var(--app-bg-04)] overflow-auto">
      <div className="privacy-policy-box">
        <div className="privacy-policy-main">
          <div className="privacy-policy-titlebox">Privacy Policy</div>
          <div className="privacy-policy-cont">
            <p className="privacy-policy-p">
              ComfortWeather Team (hereinafter referred to as "ComfortWeather" or "we") are committed to protecting and
              respecting your privacy. Therefore, we developed a Privacy Policy that covers how we collect, use,
              disclose, transfer, and store your personal data while you use our websites, mobile applications, or
              services. Please carefully read and familiarize yourself with our privacy practices before using our
              products (or services) or submitting your personal data.
            </p>
            <p className="privacy-policy-p">
              The general provisions of Section A shall apply to you, regardless of your location. Section B only
              applies to customers located in the European Union, Liechtenstein, Norway, the United Kingdom or
              Switzerland ("Europe").
            </p>
            <br />
            <p className="privacy-policy-p">This Privacy Notice will help you understand the following:</p>
            <h3 className="privacy-policy-h3">A. General Provisions</h3>
            <ul className="privacy-policy-ul">
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID1">
                  I.Definitions
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID2">
                  II.How We Use Cookies and Similar Technologies
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID3">
                  III.How We Collect and Use Your Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID4">
                  IV.How Long We Keep Your Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID5">
                  V.How We Disclose Your Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID6">
                  VI.How We Protect Your Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID7">
                  VII.Your Rights with Regards to Your Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID8">
                  VIII.How We Process Children’s Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID9">
                  IX.Third-Party Service Providers and Their Services
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID10">
                  X.How Your Personal Data Is Transferred Globally
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID11">
                  XI.How This Privacy Policy is Updated
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID12">
                  XII.Product-Specific Details
                </a>
              </li>
            </ul>
            <br />
            <h3 className="privacy-policy-h3">B. GDPR-Specific Provisions</h3>
            <p className="privacy-policy-p">The following provisions only apply to you if you live in Europe.</p>
            <br />
            <ul className="privacy-policy-ul">
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID13">
                  I.Legal Bases for the Processing of Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID14">
                  II.Additional Information on How Your Personal Data Is Transferred Globally
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID15">
                  III.Additional Information on Cookies and Other Tracking Technology
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID16">
                  IV.Additional Information on Your Rights Regarding Personal Data
                </a>
              </li>
              <li className="privacy-policy-li">
                <a className="privacy-policy-a" href="#contID17">
                  V.Contact Details of the Data Protection Officer
                </a>
              </li>
            </ul>
          </div>
          <h2>A. General Provisions</h2>
          <div className="privacy-policy-cont" id="contID1">
            <h3 className="privacy-policy-h3">I.Definitions</h3>
            <p className="privacy-policy-p">
              <strong>"Affiliated Company"</strong>
              refers to a company that is related to ComfortWeather due to joint ownership or control.
            </p>
            <p className="privacy-policy-p">
              <strong>"Third Parties"</strong>
              refers to companies or persons who do not have a related relationship arising out of joint ownership or
              control with ComfortWeather (i.e., a non-affiliated company) or other non-related persons. Third parties
              can be financial or non-financial companies, or persons other than you and ComfortWeather.
            </p>
            <p className="privacy-policy-p">
              <strong>"Personal Data"</strong>
              refers to any information relating to an identified or identifiable natural person.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID2">
            <h3 className="privacy-policy-h3">II.How We Use Cookies and Similar Technologies</h3>
            <p className="privacy-policy-p">1.What are cookies?</p>
            <p className="privacy-policy-p">
              Cookies are small text files which are transferred from our websites, applications or services and stored
              on your device. ComfortWeather’s websites, online services, interactive applications, email messages, and
              advertisements may use "cookies" and other technologies such as pixel tags and web beacons. Cookies may be
              stored on your computer for a short time (such as only while your browser is open) or for an extended
              period of time, even years. Cookies not set by this site will not be accessible to us.
            </p>
            <p className="privacy-policy-p">2.Our cookie usage</p>
            <p className="privacy-policy-p">
              (1)ComfortWeather and its partners use cookies or similar tracking technologies to better understand the
              functionality of our mobile software on your device, tell us how often you use the application, the events
              that occur within the application, aggregated usage, performance data, and where the application was
              downloaded from. We do not link the information we store within the analytics software to any personal
              data you may submit within our mobile applications.
            </p>
            <p className="privacy-policy-p">
              (2)ComfortWeather and its partners use cookies or similar tracking technologies to better understand the
              functionality of our mobile software on your device, tell us how often you use the application, the events
              that occur within the application, aggregated usage, performance data, and where the application was
              downloaded from. We do not link the information we store within the analytics software to any personal
              data you may submit within our mobile applications. and our partners use cookies or similar tracking
              technologies to analyze trends, administer the websites, track users’ movements around the websites, and
              to gather demographic information about our user base as a whole.
            </p>
            <p className="privacy-policy-p">
              (3)Many web browsers have the Do Not Track feature, which can be used to issue Do Not Track requests to
              websites. If Do Not Track is enabled on your browser, all of our websites will respect your choice.
            </p>
            <p className="privacy-policy-p">
              (4)As true of most websites, we gather certain information automatically. This information may include
              Internet Protocol (IP) addresses, browser type, Internet Service Provider (ISP), referring/exit pages, the
              files viewed on our site (e.g., HTML pages, graphics, etc.), operating system, date/time stamp, and/or
              clickstream data to analyze trends in the aggregate and administer the site.
            </p>
            <p className="privacy-policy-p">
              (5)We partner with third parties to display advertising on our website or to manage our advertising on
              other sites. Our third-party partners may use cookies or similar tracking technologies in order to provide
              you advertising based upon your browsing activities and interests.
            </p>
            <p className="privacy-policy-p">3.Removing/disabling cookies</p>
            <p className="privacy-policy-p">
              Managing your cookies and cookie preferences must be done from within your browser's options/preferences.
              Here is a list of guides on how to do this for popular browser software:
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
              >
                Microsoft Internet Explorer
              </a>
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy"
              >
                Microsoft Edge
              </a>
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
              >
                Mozilla Firefox
              </a>
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://support.google.com/chrome/answer/95647?hl=en"
              >
                Google Chrome
              </a>
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
              >
                Safari for macOS
              </a>
            </p>
            <p className="privacy-policy-p">
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-25)" }}
                href="https://support.apple.com/en-gb/HT201265"
              >
                Safari for iOS
              </a>
            </p>
            <p className="privacy-policy-p">4.More information about cookies</p>
            <p className="privacy-policy-p">
              For more information about cookies and instructions on how to adjust your browser settings to accept,
              delete or reject cookies, see the{" "}
              <a className="privacy-policy-a" style={{ color: "var(--app-text-28)" }} href="http://www.allaboutcookies.org/">
                www.allaboutcookies.org
              </a>
              website.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID3">
            <h3 className="privacy-policy-h3">III.How We Collect and Use Your Personal Data</h3>
            <p className="privacy-policy-p">
              ComfortWeather collects data for efficient operations and to provide you with the best product experience.
              Our channels for collecting personal data include: (1) you provide us your data directly, (2)we record
              certain data about how you interact with our products, and/or (3) we obtain certain data about you from
              third parties.
            </p>
            <p className="privacy-policy-p">
              The data we collect depends on the environment in which you interact with ComfortWeather, the choices you
              make, including your privacy settings and the products and features you use. It is worth noting that we
              usually treat the shipping area recorded on the mobile phone box as the actual location where your phone
              is used and comply with local laws and regulations, including those for data protection.
            </p>
            <p className="privacy-policy-p">1.Personal data we collect</p>
            <p className="privacy-policy-p">(1)Information directly provided by you</p>
            <p className="privacy-policy-p">
              The services we provide for you require you to provide information directly to us. For instance:
            </p>
            <p className="privacy-policy-p">
              Registering an ComfortWeather ID or filling out a warranty card/electronic warranty card requires you to
              create an account or to complete a personal profile. In these services, we may ask you to provide personal
              data to set up an account or a personal profile. Types of personal data include name, date of birth,
              mobile number, email address, username and password created, photos, etc.
            </p>
            <p className="privacy-policy-p">
              If you order products from us, request a return or refund, or use a paid service, we may collect your
              delivery details, bank account number, credit card details, billing address, information for credit check
              and other financial information, contact and communication records, etc., so we can process your order.
            </p>
            <p className="privacy-policy-p">
              Some of our services allow you to communicate and share with others. The communicated or shared content
              may be transmitted through and stored in our system.
            </p>
            <p className="privacy-policy-p">
              We may ask you to provide personal data and collect it under other circumstances, these circumstances
              include participating in prize draws or competitions, participating in promotional or marketing activities
              organized by us or our business partners, completing questionnaires, participating in user forums or blogs
              hosted by us or our business partners. The information you provide helps us design and improve the
              products, personalize your shopping experience, and provide purchase suggestions. We may match your
              information with third-party data to better understand your needs.
            </p>
            <p className="privacy-policy-p">(2)Service usage information</p>
            <p className="privacy-policy-p">
              In addition to the information you provide, we may also collect information about your use of our services
              through software on your device and other means. For example, we may collect:
            </p>
            <p className="privacy-policy-p">
              Device information — such as device name, device model, region and language settings, device
              identification number (IMEI number, etc.), device hardware information and status, usage habits, IP
              address, operating system version, and settings of the device used to access the service.
            </p>
            <p className="privacy-policy-p">
              Log information - Such as when and how long the services are used, search terms entered through the
              services, and error log information of the device. Because of the Android system's design, when you choose
              to share the error log information of the device with us, the Android system may sometimes simultaneously
              send us your personal information, such as your phone number, email address, social media account, etc. We
              promise not to use such information for personal identification and after analyzing the error log data, we
              will periodically clear such data (usually within 30 days after collection).
            </p>
            <p className="privacy-policy-p">
              Location information — such as the device’s GPS signal or information about nearby WiFi access points and
              cell towers, ID of the device’s location, network service provider ID, which may be sent to us when you
              use certain services. You can modify the location settings of your device from the device settings, such
              as changing or disabling the method or server used in location-based services, or modifying the accuracy
              of your location information, hence changing the location information provided to ComfortWeather.
            </p>
            <p className="privacy-policy-p">
              d.Voice information — for example, audio that we record (and may store on our servers) when you use voice
              commands to control the service.
            </p>
            <p className="privacy-policy-p">
              Album information — for example, to provide you with the function to display photo locations as well as to
              classNameify your photos and videos, we need to collect the latitude and longitude information of your
              photo and video files; when you search for a certain picture, we will collect the term you entered and the
              number of pictures identified locally .
            </p>
            <p className="privacy-policy-p">
              Camera - To ensure that the camera app works normally, we collect operational data (e.g., how many times
              you use the app), information about your device (e.g., IMEI, device model, IP address, operating system
              version), parameters of photos taken (e.g., photosensitivity, number of faces captured), and available
              space on the device.
            </p>
            <p className="privacy-policy-p">
              Other information about your use of the service - such as how you interact with the content provided
              through the service.
            </p>
            <p className="privacy-policy-p">
              Please note that we may cooperate with third-party service providers to achieve the above business
              functions, for instance, when a third-party service provider provides voice to text conversion services on
              our behalf, it may receive and store certain personal data. These third parties may not use this
              information for any other purpose.
            </p>
            <p className="privacy-policy-p">(3)Obtaining data from a third party</p>
            <p className="privacy-policy-p">
              Where permitted by law, we may collect data about you from public or commercial sources and may combine
              them with other information received or related to you. If you choose to use our services by logging in
              with third-party accounts such as Google, Facebook, Twitter, etc., we may also collect your public
              information from these services, such as your username, profile picture, etc
            </p>
            <p className="privacy-policy-p">2.How we use your personal data</p>
            <p className="privacy-policy-p">
              We may process your personal information for the purposes described in this Privacy Policy with your
              consent, to perform our obligations to you under our user agreement and/or service contract, for
              compliance with a legal obligation to which ComfortWeather is subject or when we have assessed it is
              necessary for the purposes of the legitimate interests pursued by ComfortWeather or a third party to whom
              it may be necessary to disclose information. ComfortWeather will strictly abide by the terms of this
              Privacy Policy and its updates to use your personal data. Your personal data will only be used for the
              purpose determined at the time of collection, which has been approved by you. If there is any use other
              than this, we will obtain your consent in advance. Examples of related usages are as follows:
            </p>
            <p className="privacy-policy-p">
              • Provide and improve our products. The personal data we collect will be used to provide you with
              ComfortWeather's products and services, process your orders or fulfill the contract between you and
              ComfortWeather to ensure the functionality and safety of our products and services, to verify your
              identity, to prevent and investigate fraud or other improper use.
            </p>
            <p className="privacy-policy-p">
              • Customer Support. We use data to diagnose product issues, and provide other customer care and support
              services. Your mobile user identification information, mobile device’s unique identifier, and geographic
              location information can be used to specific software licenses and may be used to invite you to
              participate in surveys. We also use this information to improve our products and analyze the efficiency of
              our business operations. However, we will not use this information to track your location. We may also
              collect your email address to reply your questions or comments raised in the “Contact Us” section of our
              websites.
            </p>
            <p className="privacy-policy-p">
              • Product Improvements. We use data to constantly improve our products, including the addition of new
              features and functionality.
            </p>
            <p className="privacy-policy-p">
              • Advertising. The personal data we collect will be used to personalize the product and to provide you
              with more tailored services, for example: your information can be used to recommend and display content
              and advertisements tailored to you on our services, or be used to conduct research and pay return visits
              to customers. In order to improve our products or services, with your consent, we may match your personal
              data (including but not limited to the de-identified location information so that it is no longer
              associated with a particular person) with third-party data to form a user profile so that we can conduct
              product development or deliver targeted product information to you (through post, email, phone and fax).
            </p>
            <p className="privacy-policy-p">
              • Commercial Promotion Activities. If you participate in prize draws, contests or similar promotional
              activities held by ComfortWeather, we will use the personal data you provide to manage such activities.
            </p>
            <p className="privacy-policy-p">
              We will acquire your consent in advance when the information is to be used for a purpose that is not
              specified in this Privacy Policy. We will acquire your consent in advance when the information collected
              for a specific purpose is to be used for other purposes. Without consent of users, we will not provide
              third parties with users’ personal data and behavior data.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID4">
            <h3 className="privacy-policy-h3">IV.How Long We Keep Your Personal Data</h3>
            <p className="privacy-policy-p">
              Our retention period for personal data is the minimum time necessary to realize the purpose of collection
              unless a longer retention period is required by law. Beyond the above retention period, we will delete or
              anonymize your personal data.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID5">
            <h3 className="privacy-policy-h3">V.How We Disclose Your Personal Data</h3>
            <p className="privacy-policy-p">
              1.At times ComfortWeather may make certain personal information available to affiliated companies and
              strategic partners that work with ComfortWeather to provide products and services. Your information will
              not be shared with third parties for their own independent marketing or commercial purposes.
            </p>
            <p className="privacy-policy-p">
              (1)Affiliated Companies: We may share your personal information with ComfortWeather's affiliated
              companies. We only share necessary personal data subject to the purposes stated in this Privacy Policy. If
              the affiliated companies wish to change the purposes of processing personal information, they will re-seek
              your authorization and consent.
            </p>
            <p className="privacy-policy-p">
              (2)Sharing with authorized partners: to realize the purposes stated in this Policy, some of our services
              will be provided by our authorized partners. We may share some personal data with our partners to provide
              better services and user experience. Third party service providers are also used to provide you with
              customer service.
            </p>
            <p className="privacy-policy-p">
              (3)Where a merger, acquisition or bankruptcy liquidation takes place, if the transfer of personal data is
              involved, we will ask the new company or organization which obtains your personal data to be subject to
              this Privacy Policy, otherwise we will ask such company or organization to acquire your authorization and
              consent again.
            </p>
            <p className="privacy-policy-p">
              We will only share your personal data for lawful, legitimate, necessary, specific and clear purposes, and
              only personal data necessary for service provision will be shared. Our partners are not allowed to use the
              shared personal data for any other purposes.
            </p>
            <p className="privacy-policy-p">
              2.We will only publicly disclose your personal data under the following circumstances:
            </p>
            <p className="privacy-policy-p">(1)After we obtain your explicit consent;</p>
            <p className="privacy-policy-p">
              (2)Disclose in accordance with laws: we may publicly disclose your personal data if it is compulsorily
              required by laws, such as to comply with a subpoena or other legal proceedings, legal actions or
              government agencies, when we believe in good faith that disclosure is necessary to protect our rights,
              protect your safety or the safety of others, investigate fraud, or respond to a government request.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID6">
            <h3 className="privacy-policy-h3">VI.How We Protect Your Personal Data</h3>
            <p className="privacy-policy-p">
              1.We have taken reasonably practical and technical measures to protect the collected information related
              to the service. However, please note that although we have taken reasonable measures to protect your
              information, no websites, Internet transmissions, computer systems or wireless connections are absolutely
              secure.
            </p>
            <p className="privacy-policy-p">
              2.We have taken safeguarding measures in accordance with industry standards to protect the personal data
              you provided and prevent data from unauthorized access, public disclosure, use, modification, damage or
              loss. We take all reasonably practical measures to protect your personal data. In particular:
            </p>
            <p className="privacy-policy-p">
              (1)We will de-identify your personal data to mitigate the risk that other organizations or individuals may
              identify you on the basis of that personal information. We use SSL to encrypt many services. We
              periodically review practices regarding information collection, storage and possessing (including physical
              security measures), to prevent various systems from unauthorized access.
            </p>
            <p className="privacy-policy-p">
              (2)We only allow ComfortWeather employees and personnel of authorized service companies who need the
              personal data to process it to access such personal data, and they are subject to strict contractual
              confidentiality obligations. If they fail to perform these obligations, they may be held liable or their
              relationship with ComfortWeather may be terminated.
            </p>
            <p className="privacy-policy-p">
              (3)The security of your information is extremely important for us. Therefore, we endeavor to ensure the
              security of your personal data and implement measures such as full security encryption during storage and
              transmission to prevent your information from unauthorized access, use, or disclosure. At the same time,
              no one can access the specific content of some encrypted data except the users themselves.
            </p>
            <p className="privacy-policy-p">
              (4)When we transmit and store special categories of your personal data, we will use security measures such
              as encryption.
            </p>
            <p className="privacy-policy-p">
              3.In the event of a personal data security incident, in accordance with legal and regulatory requirements,
              we will promptly inform you of basic information on the situation and its possible ramifications, response
              measures we have taken or will take, suggestions for you own precautions and risk reduction, remedy
              measures for you, etc.. We will inform you in a timely manner by email, post, telephone, push
              notification, etc. of the related situation. When it is impossible to notify each personal data subject
              individually, we will issue a notice using reasonable and effective methods. At the same time, we will
              take the initiative to report on the handling of the personal data security incident in accordance with
              regulatory requirements.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID7">
            <h3 className="privacy-policy-h3">VII.Your Rights with Regards to Your Personal Data</h3>
            <p className="privacy-policy-p">
              ComfortWeather will respect your legal rights to your personal data. Below are the rights that you have
              under law, and what ComfortWeather does to protect those rights. Please note that for the sake of
              security, we may ask you to verify your identity before processing your request.
            </p>
            <p className="privacy-policy-p">
              1.The right to be informed: ComfortWeather is publishing this Privacy Policy to keep you informed as to
              what we do with your personal data. We strive to be transparent about how we use your data.
            </p>
            <p className="privacy-policy-p">
              2.The right to access: If you wish to access your personal data, you can login to your account and access
              the information you provided when registering the ComfortWeather ID through "Settings - ComfortWeather
              IDs"
            </p>
            <p className="privacy-policy-p">
              3.The right to rectification: If you find that there is a mistake with your personal data we process, you
              are entitled to ask us to make rectifications. You can rectify your information via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              4.The right to erasure: You can submit a request to us to delete personal data if we do not have a legal
              reason to continue to process and hold it. You can delete your information via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              5.The right to restriction of processing: You have the right to ask ComfortWeather to restrict how we
              process your personal data. This means we are permitted to store the data but not further process it. We
              keep just enough data to make sure we respect your request in the future. You can realize your right to
              restriction of processing via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              6.The right to data portability: To the extent permitted by laws and regulations, you have the right to
              obtain a copy of your personal data in a structured, commonly used and machine-readable format. For
              example, if you decide to switch to a new provider, this will enable you to easily move, copy, or transfer
              your personal information between our IT systems and theirs in a safe and secure manner, without affecting
              its usage. You can exercise your right to the restriction of processing via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              7.The right to object: You have the right to object to ComfortWeather processing your data even if it is
              based on our legitimate interests, the exercise of official authority, direct marketing (including data
              aggregation), and processing for the purpose of statistics. You can object ComfortWeather processing your
              data via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              8.The right to withdraw consent: If you have given us your consent to process your personal data but
              change your mind later, you have the right to withdraw your consent at any time, and ComfortWeather must
              stop processing your data. You can withdraw your consent via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <p className="privacy-policy-p">
              9.The right to object automated individual decision-making: You have right not to be subject to a decision
              based solely on automated processing, including profiling. If these decisions significantly affect your
              lawful rights, you are entitled to ask for an explanation via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              , which we will respond to and take appropriate measures to resolve, as necessary.
            </p>
            <p className="privacy-policy-p">
              10.The right to lodge a complaint: You have the right to lodge a complaint with the data protection
              authority of the country you are in about the way we handle or process your personal data.
            </p>
            <p className="privacy-policy-p">
              We will respond and reply to your above requests as soon as possible, and generally within seven days and
              no later than one month upon receipt of your request. (If necessary and as permitted by law, we may extend
              it by an additional two months. We will inform you the reason for the extension within the aforementioned
              thirty-day period, for example, if the request is complex or involves a large volume of data). If you are
              not satisfied with a response you received, you can refer the complaint to the relevant regulatory
              authority in your jurisdiction.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID8">
            <h3 className="privacy-policy-h3">VIII.How We Process Children’s Personal Data</h3>
            <p className="privacy-policy-p">
              1.Our products, websites and services are mainly adult-oriented. A child should not create his/her own
              user account. We treat anyone under 16 years old (or equivalent minimum age in relevant jurisdiction) as a
              child.
            </p>
            <p className="privacy-policy-p">
              2.When we find that a child’s personal data is collected, we will delete the relevant data as soon as
              possible.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID9">
            <h3 className="privacy-policy-h3">IX.Third-Party Services Providers and Their Services</h3>
            <p className="privacy-policy-p">
              1.ComfortWeather websites, products, applications, and services may contain links to third-party websites,
              products, and services. You can choose whether to access websites, products and services provided by third
              parties or not. For example, the “follow us” function in the official website will lead you to access to
              our official accounts in social network platforms (e.g. Facebook, Instagram, LinkedIn, Twitter and etc.)
              where you can be aware of the marketing or promotional information published by ComfortWeather.
            </p>
            <p className="privacy-policy-p">
              2.We have no control over third-party privacy and data protection policies and such third parties are not
              bound by this Privacy Policy. Before submitting personal data to third parties, please refer to the
              privacy protection privacy of such third-parties.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID10">
            <h3 className="privacy-policy-h3">X.How Your Personal Data Is Transferred Globally</h3>
            <p className="privacy-policy-p">
              1.In principle, the personal data collected and produced within the territory of European Union is stored
              within the territory of the European Union.
            </p>
            <p className="privacy-policy-p">
              2.Nevertheless, we provide products and services through our resources and servers around the world. This
              means that to ensure the uniqueness of your account so that it can be used globally without being
              duplicated, after acquiring your authorization and consent, and after your personal data (i.e., IMEI,
              mobile phone number, email address, and user name) have gone through de-identification, they might be
              transmitted to or accessed from a country/region outside of the jurisdiction of the location where you use
              the products or services.
            </p>
            <p className="privacy-policy-p">
              3.Data protection laws in such jurisdictions might be different or even absent. Under such circumstances,
              we will ensure that your personal data receive adequate protection. For instance, we will ask you for your
              consent for cross-border transmission of your personal data, or implement security measures such as
              encryption, de-identification before transferring data across borders. We endeavor to apply the "Standard
              Contract Clauses" when transmitting collected personal data between the European Economic Area and China.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID11">
            <h3 className="privacy-policy-h3">XI.How This Privacy Policy Is Updated</h3>
            <p className="privacy-policy-p">
              We reserve the right to update or modify this Privacy Policy from time to time. We will send you update
              notices through different channels. If we make any material changes to our Privacy Policy, we will notify
              you by email (sent to the e-mail address specified in your account) if an email address is provided by
              you, otherwise we will notify you by posting notice on this website.
            </p>
            <p className="privacy-policy-p">
              This Privacy Policy allows adjustments, but we will not diminish your rights under this Privacy Policy
              without your express consent.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID12">
            <h3 className="privacy-policy-h3">XII.Product-Specific Details</h3>
            <p className="privacy-policy-p">
              The followings are specific privacy practices for certain ComfortWeather products and services that you
              may use.
            </p>
            <p className="privacy-policy-p">1.Account Registration Services</p>
            <p className="privacy-policy-p">
              You can use your ComfortWeather ID to enjoy ComfortWeather’s services. We may collect the following
              information you provided to create your ID: your date of birth, mobile phone number, email address,
              emergency contact person and their contact information, username created, and password you submit when you
              login to your account.
            </p>
            <p className="privacy-policy-p">
              We are authorized to use the above information you provide during your use of this service. If you log out
              of your account from all ends, you can close your account via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              . After the account is closed, we will stop providing you with products or services, and we will delete
              your personal data according to your requests, unless otherwise specified by laws and regulations.
            </p>
            <p className="privacy-policy-p">
              The above information will be stored within EU territory. However, in order to facilitate your normal use
              of the account service worldwide, we will transfer your account information outside the territory of the
              European Union. We will ensure that your personal data receives adequate protection during the process of
              the transfer. For specific protection measures, please refer to Part X on How Your Personal Data Is
              Transferred Globally.
            </p>
            <br />
            <p className="privacy-policy-p">
              If you have questions or concerns regarding our Privacy Policy or practices, please contact our Data
              Protection Officer via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <br />
          </div>
          <h2>B. GDPR-Specific Provisions</h2>
          <div className="privacy-policy-cont" id="contID13">
            <h3 className="privacy-policy-h3">I.Legal Bases for the Processing of Personal Data</h3>
            <p className="privacy-policy-p">
              Our processing of your personal data as described in the Section "How We Use Your Personal Data" is based
              on the following legal grounds:
            </p>
            <p className="privacy-policy-p">
              1. Consent: We may process your personal data with your consent. In particular, we may ask for your
              consent to participate in promotional activities, such as to send you promotional messages or enable you
              to participate in the User Experience Program and certain Services, including services through which we
              collect location information. You have the right not to provide consent, or to withdraw it at any time.
              The withdrawal of your consent does not affect the lawfulness of our use of your personal data before your
              withdrawal. If you have granted us consent to use your personal data, we will use it only for the purposes
              specified in the consent declaration. Please note that to the extent our processing is based on your
              consent and you deny your consent or withdraw it, we may not be able to provide the service relating
              thereto. Besides from that, neither the initial denial nor a withdrawal will have any negative
              consequences for you.
            </p>
            <p className="privacy-policy-p">2. Perform or enter into a contract with you:</p>
            <p className="privacy-policy-p">We rely on this legal basis in particular in the following cases:</p>
            <p className="privacy-policy-p">
              • to provide you with ComfortWeather's Services, process your orders or fulfil the contract between you
              and ComfortWeather;
            </p>
            <p className="privacy-policy-p">
              • to activate Services you have purchased, specific software licenses and provide notifications for
              software updates;
            </p>
            <p className="privacy-policy-p">
              • to allow and manage your participation in prize draws, contests or similar promotional activities held
              by us; and
            </p>
            <p className="privacy-policy-p">
              • to diagnose product issues and provide other customer care and support Services.
            </p>
            <p className="privacy-policy-p">
              3. Compliance with a legal obligation: ComfortWeather may be obliged to process personal data to comply
              with our legal obligations, for example where ComfortWeather is required to retain data for tax law or
              commercial purposes.
            </p>
            <p className="privacy-policy-p">
              4. Legitimate interests: The processing of your personal data may also be necessary for ComfortWeather's
              legitimate interests. In particular, such cases may include the following:
            </p>
            <p className="privacy-policy-p">• to conduct customer surveys to enhance your user experience;</p>
            <p className="privacy-policy-p">
              • to analyse the customer market on the basis of the country where you use our Services, including the
              number of users for product marketing and promotion;
            </p>
            <p className="privacy-policy-p">• to analyse the efficiency of our business operations;</p>
            <p className="privacy-policy-p">• to analyse error logs to improve app functions;</p>
            <p className="privacy-policy-p">
              • to provide you with personalised Services and to recommend and display content and advertisements
              tailored to you through our Services;
            </p>
            <p className="privacy-policy-p">
              • to communicate with you and reply to your questions or comments submitted to us by any means;
            </p>
            <p className="privacy-policy-p">• to ensure the functionality and safety of our Services;</p>
            <p className="privacy-policy-p">• to verify your identity;</p>
            <p className="privacy-policy-p">
              • to conduct internal auditing and to prevent and investigate fraud, cybersecurity threats or other
              improper use;
            </p>
            <p className="privacy-policy-p">
              • to enhance and develop our Services, including relevant security features, so as to improve the product
              usage experience, user-friendliness, operational performance, functions and design;
            </p>
            <p className="privacy-policy-p">• to pursue or defend against legal claims.</p>
            <p className="privacy-policy-p">
              Your personal data will only be processed on the above grounds after we have appropriately assessed and
              balanced our interests against your right to privacy.
            </p>
          </div>
          <div className="privacy-policy-cont" id="contID14">
            <h3 className="privacy-policy-h3">
              II.Additional Information on How Your Personal Data Is Transferred Globally
            </h3>
            <p className="privacy-policy-p">
              In case your personal data is transferred to jurisdictions located outside of Europe, we will ensure that
              appropriate safeguards exist and are applied, such as:
            </p>
            <p className="privacy-policy-p">
              the recipient of the personal data is located within a country that benefits from an "adequacy" decision
              of the European Commission;
            </p>
            <p className="privacy-policy-p">
              the recipient has signed a contract based on "model contractual clauses" approved by the European
              Commission, obliging them to protect your personal data;
            </p>
            <p className="privacy-policy-p">
              or in the absence of the above appropriate safeguards, we will ask you for your explicit consent for the
              cross-border transfer of your personal data or take any other measures that are recognised as providing a
              sufficient level of protection for your personal data.
            </p>
            <p className="privacy-policy-p">
              For more information about the safeguards relating to personal data transfers outside of Europe, please
              submit your request via Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
            <br />
          </div>
          <div className="privacy-policy-cont" id="contID15">
            <h3 className="privacy-policy-h3">III.Additional Information on Cookies and Other Tracking Technology</h3>
            <p className="privacy-policy-p">
              If you wish to obtain detailed information on the use of cookies and other tracking technology, please
              read our Cookies Statement.
            </p>
            <br />
          </div>
          <div className="privacy-policy-cont" id="contID16">
            <h3 className="privacy-policy-h3">IV.Additional Information on Your Rights Regarding Personal Data</h3>
            <p className="privacy-policy-p">
              Subject to the legal requirements under the GDPR, you have the following rights:
            </p>
            <p className="privacy-policy-p">
              • The right to access: You may request access to the personal data we hold about you.
            </p>
            <p className="privacy-policy-p">
              • The right to rectification: If you find that the personal data we process about you is inaccurate or
              incomplete, you are entitled to ask us to make rectifications without undue delay and to request the
              completion of your personal data where appropriate.
            </p>
            <p className="privacy-policy-p">
              • The right to erasure: You can submit a request to us to delete personal data, and we shall have the
              obligation to erase it without undue delay in some circumstances – for example, if we do not have a legal
              reason to continue to process the personal data to the extent required by applicable laws and regulations.
              Please note in so far as you delete all the data that is contained in your device, this does not mean that
              you have deleted all data that ComfortWeather collects and processes about you. Therefore, we encourage
              you to contact us (please refer to the section "Contact Us" above) to request that your personal data is
              deleted.
            </p>
            <p className="privacy-policy-p">
              • The right to restriction of processing: You have the right, in certain circumstances, to request
              ComfortWeather to temporarily restrict the processing of your personal data, such as where the accuracy of
              that personal data is contested by you, while we verify the accuracy of that personal data. We will keep
              just enough data, or process such data as is necessary to ensure that we comply with your restriction
              request in the future.
            </p>
            <p className="privacy-policy-p">
              • THE RIGHT TO OBJECT: You have the right to object to any processing justified by legitimate interests
              based on grounds relating to your particular situation at any time. Should you decide to object to the
              processing of your personal data, we will stop processing personal data that concerns you, unless we can
              demonstrate compelling reasons for continuing to process your personal data that override your interests,
              rights and freedoms, or in the case that we establish, exercise or defend our legal claims. You can object
              to direct marketing activities at any time for any reason whatsoever.
            </p>
            <p className="privacy-policy-p">
              • The right to data portability: You have the right to obtain a copy of your personal data in a
              structured, commonly-used and machine-readable format and transmit such data to another provider or have
              such data transmitted to another provider under certain circumstances.
            </p>
            <p className="privacy-policy-p">
              • The right to withdraw consent: If you have given us your consent to process your personal data but
              change your mind later, you have the right to withdraw your consent at any time. The withdrawal of your
              consent does not affect the lawfulness of our use of your personal data before your withdrawal. If you
              want to withdraw your consent with regard to receiving promotional communications, you can unsubscribe
              through the method described in each promotional message. If you withdraw your consent, we may no longer
              be able to provide you with the corresponding Service.
            </p>
            <p className="privacy-policy-p">
              • The right to lodge a complaint: You have the right to lodge a complaint with a competent supervisory
              authority about the way we handle or process your personal data, or file a lawsuit in a court with
              jurisdiction. Information about how to contact your local data protection supervisory authority is
              available{" "}
              <a
                className="privacy-policy-a"
                style={{ color: "var(--app-text-28)" }}
                href="https://edpb.europa.eu/about-edpb/board/members_en"
              >
                here
              </a>
              .
            </p>
            <br />
          </div>
          <div className="privacy-policy-cont" id="contID17">
            <h3 className="privacy-policy-h3">V.Contact Details of the Data Protection Officer</h3>
            <p className="privacy-policy-p">
              You can contact our data protection officer via the Email:{" "}
              <a className="privacy-policy-a" href="mailto:xlf550402@gmail.com" style={{ color: "var(--app-text-24)" }}>
                xlf550402@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
